import React from 'react';
import PropTypes from 'prop-types'





export default class PropTest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }
    render() {
        return (
            <div>
                <h1>{this.props.copil}</h1>
                <h2>{this.props.parinte}</h2>
            </div>
        );
    }
}



PropTest.propTypes = {
    copil:PropTypes.string,
    bunic:PropTypes.number.isRequired
    

}